import { render } from "./FullLinesField4.vue?vue&type=template&id=239cf271"
import script from "./FullLinesField4.vue?vue&type=script&lang=js"
export * from "./FullLinesField4.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__